import request from '../../../../../../helpers/request';
import { importTypes } from '../../config/import';
import { baseErrMsg, isQueryEnabled, urlKeys } from './config';
import { querySelectGetter } from './querySelectors';

const createKey = ({ url, houseId }) => [url, houseId];

const paramsGetter = {
  [urlKeys.flats]: (houseId) => ({ url: urlKeys.flats, params: { houseId } }),
  // [urlKeys.meters]: (houseId) => ({
  //   url: urlKeys.meters.replace('{houseId}', houseId),
  // }),
};

const fetch = ({ url, params = {} }) =>
  request.get(url, params, undefined, 'Error', undefined, undefined, {}, true);

export const createQueriesOptions = ({ importType, houseId }) =>
  Object.values(urlKeys).map((url) => {
    const select = querySelectGetter[url]({
      withClientsByPhone: importType === importTypes.owners,
    });

    return {
      queryKey: createKey({ url, houseId }),
      queryFn: () => fetch(paramsGetter[url](houseId)),
      staleTime: 1000 * 60 * 5,
      enabled: isQueryEnabled[url](importType),
      select,
    };
  });

export const createQueriesData = (queries) => {
  let isLoading = false;
  let error;
  const refetchs = [];
  const result = {};

  queries.forEach((query) => {
    const { data, isFetching, refetch } = query;

    if (!isLoading && isFetching) {
      isLoading = true;
    }

    if (data === 'Error') {
      refetchs.push(refetch);
      return;
    }

    if (data) {
      Object.assign(result, data);
    }
  });

  if (refetchs.length) {
    error = {
      message: baseErrMsg,
      refetch: () => Promise.all(refetchs.map((refetch) => refetch())),
    };
  }

  return { isLoading, error, result };
};
